export const userHasRoutePermission = (route_id: string, user_permissions: BeePermissions) => {
  return user_permissions.routes.includes(route_id)
}

export const userHasFeaturePermission = (feature_id: string, user_permissions: BeePermissions) => {
  return user_permissions.features.includes(feature_id)
}
